import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TextField from '@mui/material/TextField';
import React from 'react';
import { SETTINGS_ROUTES } from '../../Config/routes';
import HTTPClient from '../../Utils/HTTPClient'; // to perform API calls post and get
import Header from '../Includes/Header';
const Education = (props) => {
  // Fat Arrow functions

  const [eduField, setEduField] = React.useState(''); //usestate hook is used to handle state in functional components
  const [eduId, setEduId] = React.useState('');
  const [openDialog, setOpenDialog] = React.useState(false);
  const [eduList, setEduList] = React.useState([]);
  // const [userForm,setFormData]=React.useState({name:"",email:""});

  const handleEduInput = (e) => {
    setEduField(e.target.value);
  };

  const handleSubmitForm = () => {
    const param = { education: eduField, id: eduId };
    HTTPClient.post(SETTINGS_ROUTES.education.create(), param)
      .then((response) => {
        getEducationList();
        handleClearForm();
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getEducationList = () => {
    HTTPClient.get(SETTINGS_ROUTES.education.list())
      .then((response) => {
        setEduList(response.data.educations);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete?')) {
      const param = { id: id };
      HTTPClient.post(SETTINGS_ROUTES.education.delete(), param)
        .then((response) => {
          getEducationList();
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleEdit = (id) => {
    HTTPClient.get(SETTINGS_ROUTES.education.get(id))
      .then((response) => {
        // setEduList(response.data.educations);
        if (response.data.education) {
          setEduField(response.data.education.education);
          setEduId(response.data.education.id);
          setOpenDialog(true);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleClearForm = () => {
    setEduField('');
    setEduId('');
    setOpenDialog(false);
  };

  React.useEffect(() => {
    // this hook help us to perform lifecycle methods in react
    getEducationList();
  }, []);
  return (
    <React.Fragment>
      <Header />
      {openDialog ? (
        <Dialog open={openDialog} onClose={handleClearForm}>
          <DialogActions disableSpacing={true}>
            <IconButton
              className="close-pos close-span"
              onClick={(e) => {
                handleClearForm(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogActions>

          <DialogContent>
            <h4 className={'sethead'}>{eduId ? 'Update' : 'Create'} Education</h4>
            <div style={{ minWidth: 275 }}>
              <p>
                <TextField
                  id="outlined-basic"
                  label="Education Name"
                  variant="outlined"
                  value={eduField}
                  onChange={handleEduInput}
                  type="text"
                />
              </p>
              <Button
                disabled={eduField.length == 0}
                onClick={handleSubmitForm}
                variant="contained"
              >
                {eduId ? 'Update' : 'Create'}
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      ) : null}
      <Container maxWidth="md" className="settings-container">
        <Grid container>
          <Grid item sm={8}>
            <h2 className={'filterhead'}>Education Qualification List</h2>
          </Grid>
          <Grid item sm={4}>
            <Button
              variant="outlined"
              className="settingsnbtn"
              onClick={(e) => setOpenDialog(true)}
            >
              Add Education
            </Button>
          </Grid>
        </Grid>
        <TableContainer component={Paper}>
          <Table sx={{ width: '100%' }} aria-label="simple table" className={'sett-table'}>
            <TableHead>
              <TableRow>
                <TableCell padding={'none'}>Education</TableCell>
                <TableCell align="right" padding={'none'}>
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {eduList.map((row) => (
                <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell padding={'none'}>{row.education}</TableCell>
                  <TableCell align="right" padding={'none'}>
                    <IconButton onClick={(e) => handleEdit(row.id)} aria-label="delete">
                      <EditIcon />
                    </IconButton>
                    <IconButton onClick={(e) => handleDelete(row.id)} aria-label="delete">
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </React.Fragment>
  );
};

export default Education;
